<ng-template #component />
